import script from "./CameraDetailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraDetailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CameraDetailDialog.vue?vue&type=style&index=0&id=e1ff1b9a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ff1b9a"]])

export default __exports__